import { useState } from 'react';
import axios from '../utils/axiosWithAuth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebase';

export default function UnsubscribeForm() {
  const [user] = useAuthState(auth);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null); // 'success', 'warning', 'error'
  const [loading, setLoading] = useState(false);

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    setMessage('');
    setStatus(null);

    if (!user?.email) {
      setMessage('❌ Please log in to unsubscribe.');
      setStatus('error');
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/unsubscribe`, {

        email: user.email,
      });

      const resMsg = res.data?.message || '';

      // Set message from server
      setMessage(resMsg);

      // Handle response status
      if (resMsg.includes('✅')) {
        setStatus('success');
      } else if (resMsg.toLowerCase().includes('not found')) {
        setStatus('error');
        setMessage('❌ Email not found in subscriber list.');
      } else if (resMsg.includes('⚠️')) {
        setStatus('warning');
      } else {
        setStatus('error');
        setMessage('❌ Unsubscribe failed. Please try again.');
      }
    } catch (err) {
      console.error('Unsubscribe error:', err.response?.data || err.message);

      const serverMsg = err.response?.data?.message || '';

      if (serverMsg.toLowerCase().includes('not found')) {
        setMessage('❌ Email not found in subscriber list.');
      } else {
        setMessage('❌ Unsubscribe failed. Please try again.');
      }

      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  const getMessageColor = () => {
    if (status === 'success') return 'green';
    if (status === 'warning') return '#cc9900';
    return 'red';
  };

  return (
    <div style={{ padding: '30px', maxWidth: '400px', margin: 'auto', textAlign: 'center' }}>
      <h2 style={{ color: '#D20000' }}>Unsubscribe from Daily Job Alerts</h2>

      <form onSubmit={handleUnsubscribe}>
        <label style={{ display: 'block', marginBottom: '8px', textAlign: 'left' }}>
          Your Email:
        </label>
        <input
          type="email"
          required
          value={user?.email || ''}
          readOnly
          style={{
            padding: '12px',
            width: '100%',
            marginBottom: '12px',
            fontSize: '16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#f1f1f1',
            cursor: 'not-allowed',
          }}
        />

        <button
          type="submit"
          disabled={!user || loading}
          style={{
            padding: '12px 20px',
            backgroundColor: '#D20000',
            color: 'white',
            border: 'none',
            width: '100%',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: !user || loading ? 'not-allowed' : 'pointer',
          }}
        >
          {loading ? 'Unsubscribing...' : 'Unsubscribe'}
        </button>
      </form>

      {message && (
        <p style={{ marginTop: '15px', color: getMessageColor(), fontWeight: 'bold' }}>
          {message}
        </p>
      )}
    </div>
  );
}
